import React, { Component } from "react";


export default function (ComposedComponent) {
  class NetworkDetector extends Component {
    state = {
      isDisconnected: false,
    };

    componentDidMount() {
      this.handleConnectionChange();
      window.addEventListener("online", this.handleConnectionChange);
      window.addEventListener("offline", this.handleConnectionChange);
    }

    componentWillUnmount() {
      window.removeEventListener("online", this.handleConnectionChange);
      window.removeEventListener("offline", this.handleConnectionChange);
      // ✅ Clear interval if component unmounts mid-check
      if (this.webPing) clearInterval(this.webPing);
    }

    handleConnectionChange = () => {
      const condition = navigator.onLine ? "online" : "offline";

      if (condition === "online") {
        // ✅ Clear any existing interval before starting a new one
        if (this.webPing) clearInterval(this.webPing);

        this.webPing = setInterval(() => {
          fetch("//google.com", { mode: "no-cors" })
            .then(() => {
              this.setState({ isDisconnected: false });
              // ✅ Stop pinging once confirmed online
              clearInterval(this.webPing);
              this.webPing = null;
            })
            .catch(() => {
              // Still offline despite navigator.onLine being true
              this.setState({ isDisconnected: true });
            });
        }, 2000);

        return;
      }

      return this.setState({ isDisconnected: true });
    };

    render() {
      const { isDisconnected } = this.state;
      return (
        <div>

          <ComposedComponent {...this.props} {...this.state} />
        </div>
      );
    }
  }

  return NetworkDetector;
}